<div class="tds-container-fluid">
    <div class="tds-row">
        <h2 class="tds-headline-02">Emails para Envio de Autorizações</h2>
    </div>

    <div class="tds-row">
        <tds-table vertical-dividers="false" compact-design="false" responsive="true" no-min-width>
            <tds-table-toolbar filter>
                 <div slot="end" class="tds-u-flex tds-u-align-items-center tds-u-h-100 tds-u-gap1" style="margin-left: 8px;">
                     <tds-button variant="secondary" size="sm" title="Inserir usuário">
                         <tds-icon slot="icon" size="18px" name="plus"></tds-icon>
                     </tds-button>
                 </div>
            </tds-table-toolbar>
            <tds-table-header>
                <tds-header-cell cell-key="actions"></tds-header-cell>
                <tds-header-cell cell-key='caminhao' cell-value='Caminhão' sortable></tds-header-cell>
                <tds-header-cell cell-key='onibus' cell-value='Ônibus' sortable></tds-header-cell>
                <tds-header-cell cell-key='usuario' cell-value='Usuário' sortable></tds-header-cell>
                <tds-header-cell cell-key='email' cell-value='Email' sortable></tds-header-cell>
            </tds-table-header>
            <tds-table-body>
                <tds-table-body-row>
                    <tds-body-cell cell-key="actions">
                        <div class="action-buttons" title="Excluir">
                            <tds-icon id="edit" name="cross" size="20px" style="cursor: pointer;" ></tds-icon>
                        </div>
                    </tds-body-cell>
                    <tds-body-cell cell-key="actions">
                        <tds-checkbox value="checkbox-1" checkbox-id="first-checkbox" tds-aria-label="A checkbox component">
                        </tds-checkbox>
                    </tds-body-cell>
                    <tds-body-cell cell-key="actions">
                        <tds-checkbox value="checkbox-2" checkbox-id="second-checkbox" tds-aria-label="A checkbox component">
                        </tds-checkbox>
                    </tds-body-cell>
                    <tds-body-cell cell-key="solic">SSBADD</tds-body-cell>
                    <tds-body-cell cell-key="razaoSocial">ADILSON.PEREIRA&#64;SCANIA.COM</tds-body-cell>
                </tds-table-body-row>
            </tds-table-body>
        </tds-table>
    </div>
</div>